// frontend/src/components/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaXTwitter, FaLinkedinIn, FaInstagram } from 'react-icons/fa6';
import logo from '../assets/images/logo.png';
import './Footer.css';

const footerLinks = {
  Platform: [
    { label: 'For Providers', to: '/providers' },
    { label: 'For Employers', to: '/employers' },
    { label: 'Market Reports', to: '/resources/market-report' },
  ],
  Company: [
    { label: 'Blog', to: '/blog' },
  ],
  Legal: [
    { label: 'Privacy Policy', to: '/privacy-policy' },
    { label: 'Terms of Service', to: '/terms-of-service' },
  ],
};

const socialLinks = [
  { Icon: FaFacebook, href: 'https://www.facebook.com/profile.php?id=61571625713755', label: 'Facebook' },
  { Icon: FaXTwitter, href: 'https://x.com/RxRooster', label: 'X / Twitter' },
  { Icon: FaLinkedinIn, href: 'https://www.linkedin.com/company/rx-rooster/', label: 'LinkedIn' },
  { Icon: FaInstagram, href: 'https://www.instagram.com/rx_rooster/', label: 'Instagram' },
];

const Footer = () => {
  return (
    <footer className="rxr-footer" id="site-footer">
      {/* ── Top accent line ── */}
      <div className="rxr-footer__accent" aria-hidden="true" />

      <div className="rxr-footer__inner">
        {/* ── Brand column ── */}
        <div className="rxr-footer__brand">
          <Link to="/" className="rxr-footer__logo-link" aria-label="RxRooster Home">
            <img src={logo} alt="RxRooster" width="160" height="40" loading="lazy" decoding="async" className="rxr-footer__logo" />
          </Link>
          <p className="rxr-footer__tagline">The Anesthesia Career Platform.</p>
          <div className="rxr-footer__socials">
            {socialLinks.map(({ Icon, href, label }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                className="rxr-footer__social-icon"
                aria-label={label}
              >
                <Icon />
              </a>
            ))}
          </div>
        </div>

        {/* ── Link columns ── */}
        <nav className="rxr-footer__nav" aria-label="Footer navigation">
          {Object.entries(footerLinks).map(([heading, links]) => (
            <div className="rxr-footer__col" key={heading}>
              <h4 className="rxr-footer__col-heading">{heading}</h4>
              <ul className="rxr-footer__col-list">
                {links.map(({ label, to }) => (
                  <li key={label}>
                    <Link to={to} className="rxr-footer__link">{label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </nav>
      </div>

      {/* ── Bottom bar ── */}
      <div className="rxr-footer__bottom">
        <div className="rxr-footer__bottom-inner">
          <span className="rxr-footer__copyright">
            &copy; {new Date().getFullYear()} RxRooster, LLC. All rights reserved.
          </span>
          <p className="rxr-footer__disclaimer">
            RxRooster is an anesthesia career platform with a self-service
            marketplace connecting providers with employers. Our role ends at
            the interview. We do not employ clinicians, set compensation, or receive revenue
            tied to patient care. All credentialing, contracting, and
            clinical arrangements are handled solely between the provider
            and the facility or group.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
